import { EMManagementId } from 'components/EMManagement/EMManagementId';
import { Page } from 'layouts/Page';

export const EMManagementIdPage = () => {
	return (
		<Page title="EM Management – EAS Control Center">
			<EMManagementId />
		</Page>
	);
};
